// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import { TruArrow } from '@uswitch/spark-icons/tru'
import { gtmTrack } from '@u/tracking'

const onClick = (text) => gtmTrack('GA Button Clicked', 'Functional Interaction', `${text}`)

const Tile = (props) => {
  const { content = '', href, children } = props

  return (
    <a
      href={href}
      onClick={() => (props.onClick ? props.onClick() : onClick(content || children))}
      sx={{
        display: 'block',
        bg: 'white',
        boxShadow: '0px 4px 22px rgba(0, 0, 0, 0.18)',
        height: ['82px', '150px', '217px'],
        width: ['100%', '150px', '217px'],
        ':nth-child(odd)': {
          mr: ['0', '0', 'lg'],
        },
        ':first-child': {
          ml: [0, '32px', 0],
        },
        ':last-child': {
          mr: [0, '32px', 0],
        },
        border: '2px solid transparent',
        mb: ['sm', 'md', 'md'],
        position: 'relative',
        '&:hover': {
          cursor: 'pointer',
          border: '2px solid',
          borderColor: 'primary',
          color: 'inherit',
        },
        '&:visited': {
          colour: 'black',
        },
      }}
    >
      <div
        sx={{
          position: 'absolute',
          top: ['27px', '27px', '18px'],
          right: '24px',
          display: ['none', 'none', 'block'],
        }}
      >
        <TruArrow color='black' size={28} sx={{ transform: 'rotate(0.25turn)' }} />
      </div>

      <div
        sx={{
          position: 'absolute',
          top: ['27px', '20px', '18px'],
          right: ['24px', '19px', '24px'],
          display: ['block', 'block', 'none'],
        }}
      >
        <TruArrow color='black' size={24} sx={{ transform: 'rotate(0.25turn)' }} />
      </div>

      <div sx={{ position: 'absolute', bottom: '18px', px: ['sm', '10px', 'sm'] }}>
        <p sx={{ fontSize: ['xs', '14px', 'xs'], color: 'grey-60', mb: 'xs' }}>I want to</p>
        <h3 sx={{ m: '0', color: 'black', fontSize: ['revert', '14px', 'revert'] }}>
          {content || children}
        </h3>
      </div>
    </a>
  )
}

export default Tile
